import httpClient, { downloadFile } from '@/api/httpClient'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
import Retry from '../../components/Retry'
import Pagination from '../../components/metapic/page/Pagination.vue'
import { caseOf, map } from '../../lib'
import { formatPrice } from '../../utils/price'

const paymentTypesMap = {
  cpc: 'CPC',
  cpa: 'CPA',
  one_time_earnings: 'Additional payment',
}

export default {
  data() {
    return {
      expandedUsers: [],
    }
  },

  computed: {
    ...mapGetters('payments', [
      'payments',
      'paymentDates',
      'selectedPaymentDate',
      'paymentDateRaw',
      'selectedMarket',
      'paymentsListPerPage',
    ]),
    ...mapState('payments', ['userPaymentParts', 'pagination', 'currentPaymentId', 'selectedPaymentErrorType']),
  },

  methods: {
    ...mapActions('payments', [
      'init',
      'selectPaymentDate',
      'selectPaymentTypes',
      'selectMarket',
      'loadPayments',
      'approvePayment',
      'unapprovePayment',
      'approvePaymentInvoice',
      'recalculatePayment',
      'loadUserPaymentParts',
    ]),
    ...mapMutations('payments', ['update']),
    async exportInvoice(invoiceId) {
      try {
        await downloadFile(httpClient, `/paymentsInvoice/${invoiceId}?format=xlsx&paymentErrorType=${this.selectedPaymentErrorType}`)
      } catch (error) {
        console.error('Export failed:', error)
        alert('Export failed. Please try again.')
      }
    },
    async fetchUserPaymentParts(id) {
      if (!this.userPaymentParts[id] && !this.expandedUsers.includes(id)) {
        await this.loadUserPaymentParts(id)
        this.expandedUsers.push(id)
      } else if (this.userPaymentParts[id] && this.expandedUsers.includes(id)) {
        this.expandedUsers = this.expandedUsers.filter((item) => item !== id)
      } else if (this.userPaymentParts[id] && !this.expandedUsers.includes(id)) {
        this.expandedUsers.push(id)
      }
    },
    fetchPayments(value) {
      this.update({ path: 'currentPaymentId', value })
      this.loadPayments()
    },
  },
  created() {
    this.init()
  },

  render() {
    return (
      <div class="payment-page">
        {caseOf(this.paymentDates, {
          Pending: () => (
            <div class="spinner-container">
              <div class="spinner" />
            </div>
          ),
          Done: (paymentDatesv2) => (
            <div>
              <div class="select-payment-grid">
                <select class="error-type-selector" onChange={(value) => this.selectMarket({ value: value.target.value })}>
                  <option value="ALL" default>
                    All
                  </option>
                  <option value="AU">Australia</option>
                  <option value="AT">Austria</option>
                  <option value="BE">Belgium</option>
                  <option value="CZ">Czechia</option>
                  <option value="DK">Denmark</option>
                  <option value="FI">Finland</option>
                  <option value="FR">France</option>
                  <option value="DE">Germany</option>
                  <option value="GB">Great Britain</option>
                  <option value="IE">Ireland</option>
                  <option value="IT">Italy</option>
                  <option value="NL">Netherlands</option>
                  <option value="NO">Norway</option>
                  <option value="PL">Poland</option>
                  <option value="PT">Portugal</option>
                  <option value="RO">Romania</option>
                  <option value="SK">Slovakia</option>
                  <option value="ES">Spain</option>
                  <option value="SE">Sweden</option>
                  <option value="US">United States</option>
                </select>
                <select
                  class="date-selector"
                  onChange={(value) =>
                    this.selectPaymentDate({
                      value: value.target.value,
                    })
                  }
                >
                  {map(paymentDatesv2, (paymentDate) => {
                    if (paymentDate.selected) {
                      return <option selected>{paymentDate.payment_date}</option>
                    } else {
                      return <option>{paymentDate.payment_date}</option>
                    }
                  })}
                </select>
                <select
                  class="error-type-selector"
                  onChange={(value) =>
                    this.selectPaymentTypes({
                      value: value.target.value,
                    })
                  }
                >
                  <option value="0">Valid payments</option>
                  <option value="2">Missing info</option>
                  <option value="1">Under limit</option>
                  <option value="3">Inactive</option>
                  <option value="4">Not accepted in time</option>
                  <option value="7">User are blocked</option>
                  <option value="8">Invalid VAT</option>
                </select>
              </div>
              <div class="payment-routes">
                <router-link style="margin-right: 20px;" title="Do payments" to="/payments/do">
                  Do payments
                </router-link>
                <router-link title="Store invoice payments" to="/storeInvoicePayments">
                  Store invoice payments
                </router-link>
                <router-link title="Client Org invoice payments" to="/clientInvoicePayments">
                  Client invoice payments
                </router-link>
              </div>
            </div>
          ),
          Error: () => <Retry refresh={() => this.init()} />,
          _: () => null,
        })}

        {caseOf(this.payments, {
          Pending: () => (
            <div class="spinner-container">
              <div class="spinner" />
            </div>
          ),
          Done: (paymentsInvoices) => (
            <div>
              {map(paymentsInvoices, (paymentsInvoice) => {
                return (
                  <div class="payment-invoice">
                    <button onClick={() => this.fetchPayments(paymentsInvoice.id)}>
                      <span class="payments-invoice-text">
                        <span>{paymentsInvoice.name}</span>
                        <span>user: {paymentsInvoice.total_payment.user_earnings_formatted} </span>
                        <span>client: {paymentsInvoice.total_payment.client_earnings_formatted}</span>
                      </span>
                      <button class="export-button" type="button" onClick={() => this.exportInvoice(paymentsInvoice.id)}>
                        Export
                      </button>

                      {paymentsInvoice.able_to_be_accepted && (
                        <button
                          class="approve-button"
                          disabled={paymentsInvoice.total_payment.is_approved == 1 || this.paymentDateRaw.locked == 1}
                          onClick={() =>
                            this.approvePaymentInvoice({
                              value: paymentsInvoice.id,
                            })
                          }
                        >
                          {paymentsInvoice.total_payment.is_approved ? 'Approved' : 'Approve'}
                        </button>
                      )}
                    </button>
                    <div>
                      {this.currentPaymentId === paymentsInvoice.id && this.paymentsListPerPage.length > 0 && (
                        <div class="invoice-user-wrap">
                          <Pagination
                            currentPage={this.pagination.current}
                            lastPage={this.pagination.last}
                            onPageChange={this.loadPayments}
                          />
                          {map(this.paymentsListPerPage, (payment) => (
                            <div onClick={() => this.fetchUserPaymentParts(payment.id)} className="invoice-user">
                              <div className="user-header">
                                <span className="fw-500">
                                  UserId: <router-link to={`/users/${payment.creator.id}`}>{payment.creator.id}</router-link>
                                </span>
                                <span>
                                  <span className="fw-500">Email: </span>
                                  {payment.creator.email}
                                </span>
                                <span>
                                  <span className="fw-500">Username: </span>
                                  {payment.creator.username}
                                </span>
                              </div>
                              <div className="user-data">
                                <span>
                                  <span className="fw-500">User earnings: </span>
                                  {formatPrice(payment.creator_cost.amount, payment.creator_cost.currency)}
                                </span>
                                <span>
                                  <span className="fw-500">Client earnings: </span>
                                  {formatPrice(payment.client_cost.amount, payment.client_cost.currency)}
                                </span>
                                <span>
                                  <span className="fw-500">Status: </span>
                                  {payment.status || '—'}
                                </span>
                              </div>
                              <div>
                                {!payment.accepted_at && (
                                  <span className="approve-button-container">
                                    {!payment.recalculate && (
                                      <button
                                        className="approve-button"
                                        disabled={this.paymentDateRaw.locked == 1}
                                        onClick={() =>
                                          this.recalculatePayment({
                                            value: payment.id,
                                          })
                                        }
                                      >
                                        Recalulate
                                      </button>
                                    )}
                                    {payment.recalculate && (
                                      <button
                                        className="approve-button"
                                        disabled={true}
                                        onClick={() =>
                                          this.recalculatePayment({
                                            value: payment.id,
                                          })
                                        }
                                      >
                                        Recalculating refresh after 1 min.
                                      </button>
                                    )}
                                    {payment.able_to_be_accepted && (
                                      <button
                                        className="approve-button"
                                        disabled={this.paymentDateRaw.locked == 1}
                                        onClick={() =>
                                          this.approvePayment({
                                            value: payment.id,
                                          })
                                        }
                                      >
                                        Approve
                                      </button>
                                    )}
                                  </span>
                                )}
                                {payment.accepted_at && (
                                  <button
                                    className="approve-button"
                                    disabled={this.paymentDateRaw.locked == 1}
                                    onClick={() =>
                                      this.unapprovePayment({
                                        value: payment.id,
                                      })
                                    }
                                  >
                                    Unapprove
                                  </button>
                                )}
                              </div>
                              {this.expandedUsers.includes(payment.id) && !!Object.keys(this.userPaymentParts[payment.id]).length && (
                                <div>
                                  {map(Object.keys(this.userPaymentParts[payment.id]), (month) => (
                                    <div>
                                      <b>{month}</b>
                                      <div class="payment-types-block">
                                        {map(Object.keys(this.userPaymentParts[payment.id][month]), (paymentType) => (
                                          <div class="payment-type-item">
                                            <b class="payment-type-name">{paymentTypesMap[paymentType]}</b>
                                            {map(Object.keys(this.userPaymentParts[payment.id][month][paymentType]), (store) => {
                                              const storeValue = this.userPaymentParts[payment.id][month][paymentType][store]
                                              if (storeValue.user_earnings) {
                                                const currency = paymentsInvoice.total_payment.currency_obj.symbol
                                                return (
                                                  <div>
                                                    <b class="store-name">{storeValue.feed_name}:</b>
                                                    {Number(storeValue.user_earnings / 100).toFixed(2)}
                                                    {currency}
                                                  </div>
                                                )
                                              }
                                            })}
                                          </div>
                                        ))}
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                              {this.expandedUsers.includes(payment.id) && !Object.keys(this.userPaymentParts[payment.id]).length && (
                                <div class="no-user-parts">No user parts for this user</div>
                              )}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </div>
                )
              })}
            </div>
          ),
          Error: () => <Retry refresh={() => this.init()} />,
          _: () => null,
        })}
      </div>
    )
  },
}
